import React, { useState } from 'react';

import { ModalWindowApiContext, ModalWindowItemInternal } from './ModalWindowApiContext';
import ModalWindowResolver from './ModalWindowResolver';

interface IModalWindowApiProviderProps {
  children: any;
}

export function ModalWindowApiProvider({ children }: IModalWindowApiProviderProps) {
  const [modals, setModals] = useState<ModalWindowItemInternal[]>([]);

  const close = (id: UUID) => {
    setModals((prevState) => {
      return prevState.filter((item) => item.id !== id);
    });
  };

  const add = (newModal: ModalWindowItemInternal) => {
    setModals((prevState) => [...prevState, newModal]);
    return newModal.id;
  };

  const clearAll = () => {
    setModals([]);
  };

  return (
    <ModalWindowApiContext.Provider
      value={{
        add,
        close,
        clearAll
      }}
    >
      {children}

      {modals.map((item) => {
        return (
          <ModalWindowResolver
            key={item.id}
            close={close}
            modalWindowItem={item}
          />
        );
      })}
    </ModalWindowApiContext.Provider>
  );
}
